export default __webpack_public_path__ + "static/media/service-2.a826866a.png";